<template>
  <div :class="{ 'mb-9': ((roleInSpace == 'space_admin' || roleInSpace == 'booster') && productPlan.attributes && productPlan.attributes.name == 'Pro Trial') || roleInSpace == 'space_admin' && subscriptionEnds || (role == 'space_admin' && productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due')) }">
    <AlertMessages
      v-if="alertValue"  
      :alert-type="alertType" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <SystemBarTopTrial v-if="(roleInSpace == 'space_admin' || roleInSpace == 'booster') && productPlan.attributes && productPlan.attributes.name == 'Pro Trial'"/>
    <SystemBarTopCancelSubscription v-if="roleInSpace == 'space_admin' && subscriptionEnds"/>
    <SystemBarTopPaymentFailed v-if="roleInSpace == 'space_admin' && productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due')"/>
    <v-app-bar
      app
      clipped-left
      elevation="0"
      outlined
      v-if="!loadingData"
    > 
           <v-tooltip
          v-if="isAuth"
          bottom
        >
           <template v-slot:activator="{ on, attrs }">
            <v-btn
              min-width="52"
              rounded
              elevation="0"
              class="pa-4 ml-n2"
              data-testid="exit-button"    
              v-bind="attrs"
              @click="exitHub"
              v-on="on">
            <v-icon>
                mdi-chevron-left
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('exitHubTooltip') }}</span>
        </v-tooltip>
   
      <v-toolbar-title class="ml-n3">
       <router-link
          v-if="!mobile()"
          to="/"
        >
          <v-img
            v-if="logo == null"
            data-testid="logo-space"
            src="../assets/rtplogo.svg"
            max-height="40"
            :max-width="mobile() ? '40' : '150' "
            class="d-none d-sm-block mx-4 justify-center"
            contain
            position="top left"
          />
          <v-img
            v-else
            data-testid="logo-space"
            :src="logo"
            max-height="40"
            :max-width="mobile() ? '40' : '150' "
            class="d-none d-sm-block mx-4 justify-center"
            contain
            position="top left"
          />
        </router-link>
         <router-link
         v-else
          to="/"
        >
          <v-img
            v-if="icon == null"
            data-testid="logo-space"
            src="../assets/rtpicon.png"
            max-height="40"
            :max-width="mobile() ? '40' : '40' "
            class="justify-center mx-4"
            contain
            position="top left"
          />
          <v-img
            v-else
            data-testid="logo-space"
            :src="icon"
            max-height="40"
            :max-width="mobile() ? '40' : '40' "
            class="justify-center mx-4"
            contain
            position="top left"
          />
        </router-link>
      </v-toolbar-title>
            <h3
        v-if="!mobile() && role == 'booster'"
        class="pl-6 no-break activity-title activity-title-edit"
      >
        <div>
          <v-clamp
            v-if="showHubTitle==false"
            autoresize
            :max-lines="2"
            @dblclick.native="counter += 2, showEditTitleField()"
          >
            {{ hubTitle }}
          </v-clamp>
          <v-form
            v-if="showHubTitle==true"
            ref="form"
            v-model="valid"
            @submit.prevent
            @keydown.enter.prevent
          >
            <v-text-field
              v-model="hubTitle"
              autofocus
              data-testid="title-input"
              class="mt-0 pt-0"
              hide-details
              v-focus-outside="onClickOutside"
              :append-icon="valid ? 'mdi-check-bold' : ''"
              :rules="titleRules"
              @click:append="editTitle()"
              @keydown.enter="editTitle()"
              @click.stop.prevent
              @keydown.enter.stop.prevent
            />
          </v-form>
          <v-tooltip
            v-if="showHubTitle==false"
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                data-testid="edit-hub-title-button"
                icon
                class="ml-1 dots-vertical"
                small
                v-bind="attrs"
                v-on="on"
                @click.stop.prevent="showEditTitleField()"
              >
                <v-icon small>
                  mdi-pencil
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('editHubTooltip') }}</span>
          </v-tooltip>
        </div>
      </h3>
      <h3
        v-if="!mobile() && role != 'booster'"
        class="pl-6 no-break activity-title-edit"
      >
        <v-clamp
          autoresize
          :max-lines="2"
        >
          {{ hubTitle }}
        </v-clamp>
      </h3>
      <h4
        v-if="mobile()"
        style="font-size:14px"
        class="pl-3 no-break"
      >
        <v-clamp
          autoresize
          :max-lines="1"
        >
          {{ hubTitle }}
        </v-clamp>
      </h4>
      <v-tooltip
        v-if="!mobile() && role == 'booster'"
        bottom
      >
        <template v-slot:activator="{ on }">
          <v-chip
            small
            data-testid="sharing-setting-chip"
            color="darktext"
            text-color="white"
            filter-icon="mdi-equalizer-outline"
            class="ml-4 sharing-setting-chip"
            v-on="on"
            @click.stop="
              dialogVisibleChangeSharingSettings = true, 
              confirmationDialogTitle=$t('confirmationDialogTitleChangeSharingSettings'),
              confirmationDialogSubmitBtn=$t('save')
              confirmationDialogCancelBtn=$t('cancel')"
          >
            <v-icon
              size="14"
              class="pr-1"
            >
              mdi-share-variant
            </v-icon>
            {{ hubTypeName }}
          </v-chip>
        </template>
        <span>{{ $t('sharingSettingsChipTooltip') }}</span>
      </v-tooltip>
      <v-chip
        v-if="!mobile() && role != 'booster' && isAuth"
        small
        data-testid="sharing-setting-chip"
        color="darktext"
        text-color="white"
        filter-icon="mdi-equalizer-outline"
        class="ml-4 sharing-setting-chip">
        <v-icon
          size="14"
          class="pr-1"
        >
          mdi-share-variant
        </v-icon>
        {{ hubTypeName }}
      </v-chip>
      
      <v-spacer />
      <!--booster i desktop--->
      <div>
      <ContactUs v-if="(role == 'booster' || role == 'space_admin') && space!='id' && !mobile()" />
      </div>
      <div>
      <v-tooltip
        v-if="role == 'booster' && !mobile()"
        data-testid="analytics-icon-hub"
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            rounded
            elevation="0"
            v-bind="attrs"
            @click="openPeopleInHub"
            v-on="on"
          >
            <v-icon>mdi-equalizer-outline</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('analyticsInHubTooltip') }}</span>
      </v-tooltip>

      <v-menu
        v-if="!mobile() && role == 'booster'"
        data-testid="share-hub-icon"
        offset-y
        flat
      >
        <template v-slot:activator="{ on: menu }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                rounded
                elevation="0"
                data-testid="share-hub-button"
                v-on="{ ...tooltip, ...menu }"
              >
                <v-icon>mdi-share-variant</v-icon>                    
              </v-btn>
            </template>
            <span>{{ $t('shareHubTooltip') }}</span>
          </v-tooltip>
        </template>
        <v-list
          data-testid="menu-list"
        >
          <v-list-item
            router
            :to="'/hub/'+ $route.params.id + '/owners/add'"
            data-testid="add-owners-hub-item"
          >
            <v-list-item-title class="pr-2">
              {{ $t('addOwners') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            router
            :to="'/hub/'+ $route.params.id + '/share'"
            data-testid="share-activity-item"
          >
            <v-list-item-title class="pr-2">
              {{ $t('directShare') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            data-testid="copy-link-item"
            @click="copySharingLink"
          >
            <v-list-item-title class="pr-2">
              {{ $t('copySharingLink') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            data-testid="qr-code-item"
            router
            :to="'/hub/'+ $route.params.id + '/qr-code'"
          >
            <v-list-item-title class="pr-2">
              {{ $t('qrCode') }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
        
      </v-menu>
    <v-menu
        v-if="!mobile() && role != 'booster' && (showCopiedLink || (productPlan.attributes && productPlan.attributes.name != 'Free' && role == 'participant' && (roleInSpace == 'booster' || roleInSpace == 'space_admin')))"
        data-testid="share-hub-icon"
        offset-y
        flat
      >
        <template v-slot:activator="{ on: menu }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                rounded
                elevation="0"
                data-testid="share-hub-button"
                v-on="{ ...tooltip, ...menu }"
              >
                <v-icon>mdi-share-variant</v-icon>                    
              </v-btn>
            </template>
            <span>{{ $t('shareHubTooltip') }}</span>
          </v-tooltip>
        </template>
          <v-list
          data-testid="menu-list"
        >
          <v-list-item
            v-if="showCopiedLink"
            data-testid="copy-link-item"
            @click="copySharingLink"
          >
            <v-list-item-title class="pr-2">
              {{ $t('copySharingLink') }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item
              v-if="productPlan.attributes && productPlan.attributes.name != 'Free' && role == 'participant' && (roleInSpace == 'booster' || roleInSpace == 'space_admin')"
              data-testid="request-owner-item"
              @click.stop="
                dialogRequestOwnerRights = true, 
                confirmationDialogTitle = $t('confirmationDialogTitleRequestOwnerRights'), 
                confirmationDialogText = $t('confirmationDialogTextRequestOwnerRights'), 
                confirmationDialogSubmitBtn = $t('send'),
                confirmationDialogCancelBtn = $t('cancel'),
                cdSubmitBtnColor='accent',
                cdCancelBtnColor='darktext'"
            >
              <v-list-item-title class="pr-2">
                {{ $t('requestOwnerRights') }}
              </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>


      <v-tooltip
        v-if="role == 'booster' && !mobile()"
        data-testid="settings-icon"
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            rounded
            elevation="0"
            v-bind="attrs"
            @click="openHubSettingsDialog"
            v-on="on"
            data-testid="settings-button"
          >
            <v-icon>mdi-cog</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('settingsEditHubTooltip') }}</span>
      </v-tooltip>
      </div>

      <div v-if="!mobile()">
        <v-tooltip
          bottom
          v-if="!isAuth"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              ref="loginDialog"
              data-testid="login-button"
              rounded
              elevation="0"
              v-bind="attrs"
              v-on="on"
              @click="
                dialogVisible=true, 
                confirmationDialogTitle=$t('confirmationDialogTitleWithoutLogin'), 
                confirmationDialogText=$t('confirmationDialogTextWithoutLogin'),
                cdSubmitBtnColor='accent', 
                cdCancelBtnColor='darktext',
                confirmationDialogSubmitBtn=$t('login')
                confirmationDialogLinkBtn=$t('createNewAccount')
                confirmationDialogCancelBtn=$t('skip')"
            >
              {{ $t('login') }}
              <v-icon>mdi-login</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('login') }}</span>
        </v-tooltip>
      </div>

      <div v-else>
        <!--mobile -->
        <div v-if="isAuth">
          <v-menu
            v-if="role == 'booster' || role == 'space_admin'"
            offset-y
            rounded-lg
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class=" px-5 py-3"
                height="100%"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon large>
                  mdi-menu-down
                </v-icon>
              </v-btn>
            </template>

            <v-list
              class="menulist-drawer"
              data-testid="menu-list"
            >
              <v-list-item @click="openPeopleInHub">
                <v-list-item-title>{{ $t('overview') }}</v-list-item-title>
              </v-list-item>
              <v-list-item :to="'/hub/'+ $route.params.id + '/owners/add'">
                <v-list-item-title>{{ $t('addOwners') }}</v-list-item-title>
              </v-list-item>
              <v-list-item :to="'/hub/'+ $route.params.id + '/share'">
                <v-list-item-title>{{ $t('directShare') }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="copySharingLink">
                <v-list-item-title>{{ $t('copySharingLink') }}</v-list-item-title>
              </v-list-item>
              <v-list-item :to="'/hub/'+ $route.params.id + '/qr-code'">
                <v-list-item-title>{{ $t('qrCode') }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                target="_blank"
                href="https://skillboost.io/kom-igang/"
              >
                <v-list-item-title class="pr-2">
                  {{ $t('tutorialsLiveChat') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-menu
            v-if="role != 'booster' && (showCopiedLink || (productPlan.attributes && productPlan.attributes.name != 'Free' && role == 'participant' && (roleInSpace == 'booster' || roleInSpace == 'space_admin')))"

            offset-y
            rounded-lg
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class=" px-5 py-3"
                height="100%"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon large>
                  mdi-menu-down
                </v-icon>
              </v-btn>
            </template>

            <v-list
              class="menulist-drawer"
              data-testid="menu-list"
            >
              <v-list-item v-if="showCopiedLink" @click="copySharingLink">
                <v-list-item-title>{{ $t('copySharingLink') }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="productPlan.attributes && productPlan.attributes.name != 'Free' && role == 'participant' && (roleInSpace == 'booster' || roleInSpace == 'space_admin')"
                @click.stop="
                  dialogRequestOwnerRights = true, 
                  confirmationDialogTitle = $t('confirmationDialogTitleRequestOwnerRights'), 
                  confirmationDialogText = $t('confirmationDialogTextRequestOwnerRights'), 
                  confirmationDialogSubmitBtn = $t('send'),
                  confirmationDialogCancelBtn = $t('cancel'),
                  cdSubmitBtnColor='accent',
                  cdCancelBtnColor='darktext'"
              >
                <v-list-item-title class="pr-2">
                  {{ $t('requestOwnerRights') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <div v-else>
          <v-menu
            v-if="!mobile()"
            offset-y
            flat
          >
            <template v-slot:activator="{ on: menu }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn
                    rounded
                    elevation="0"
                    v-on="{ ...tooltip, ...menu }"
                  >
                    <v-icon>mdi-share-variant</v-icon>                    
                  </v-btn>
                </template>
                <span>{{ $t('shareHubTooltip') }}</span>
              </v-tooltip>
            </template>
            <v-list data-testid="menu-list">
              <v-list-item
                data-testid="copy-link-item"
                @click="copySharingLink"
              >
                <v-list-item-title class="pr-2">
                  {{ $t('copySharingLink') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-tooltip
            v-if="!mobile()"
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                ref="loginDialog"
                data-testid="login-button"
                rounded
                elevation="0"
                v-bind="attrs"
                v-on="on"
                @click="
                  dialogVisible=true, 
                  confirmationDialogTitle=$t('confirmationDialogTitleWithoutLogin'), 
                  confirmationDialogText=$t('confirmationDialogTextWithoutLogin'),
                  cdSubmitBtnColor='accent', 
                  cdCancelBtnColor='darktext',
                  confirmationDialogSubmitBtn=$t('login')
                  confirmationDialogLinkBtn=$t('createNewAccount')
                  confirmationDialogCancelBtn=$t('skip')"
              >
                {{ $t('login') }}
                <v-icon>mdi-login</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('login') }}</span>
          </v-tooltip>
          <v-menu
            v-if="mobile()"
            offset-y
            rounded-lg
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class=" px-5 py-3"
                height="100%"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon large>
                  mdi-menu-down
                </v-icon>
              </v-btn>
            </template>

            <v-list
              class="menulist-drawer"
              data-testid="menu-list"
            >
              <v-list-item
                @click="copySharingLink()"
              >
                <v-list-item-title>{{ $t('copySharingLink') }}</v-list-item-title>
              </v-list-item>
              <v-list-item  
                ref="loginDialog"
                data-testid="login-button"
                rounded
                elevation="0"
                @click="
                  dialogVisible=true, 
                  confirmationDialogTitle=$t('confirmationDialogTitleWithoutLogin'), 
                  confirmationDialogText=$t('confirmationDialogTextWithoutLogin'),
                  cdSubmitBtnColor='accent', 
                  cdCancelBtnColor='darktext',
                  confirmationDialogSubmitBtn=$t('login')
                  confirmationDialogLinkBtn=$t('createNewAccount')
                  confirmationDialogCancelBtn=$t('skip')"
              >
                <v-list-item-title>{{ $t('login') }} <v-icon>mdi-login</v-icon></v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
    </v-app-bar>

    <ConfirmationDialog
        v-if="dialogRequestOwnerRights"
        :visible="dialogRequestOwnerRights"
        :cd-title="confirmationDialogTitle"
        :cd-text="confirmationDialogText"
        :cd-submit-btn="confirmationDialogSubmitBtn"
        :cd-cancel-btn="confirmationDialogCancelBtn"
        :cd-cancel-btn-color="cdCancelBtnColor"
        :cd-submit-btn-color="cdSubmitBtnColor"
        data-testid="request-owners-rights-dialog" 
        @proceedSubmit="sendRequestOwnerRights"
        @close="dialogRequestOwnerRights =false"
    />
    
    <ConfirmationDialogWithLink 
      v-if="dialogVisible"
      ref="confirmationDialogWithLink"
      :visible="dialogVisible"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText" 
      :cd-submit-btn="confirmationDialogSubmitBtn" 
      :cd-link-btn="confirmationDialogLinkBtn" 
      :cd-cancel-btn="confirmationDialogCancelBtn" 
      :cd-cancel-btn-color="cdCancelBtnColor" 
      :cd-submit-btn-color="cdSubmitBtnColor"
      :cd-idps="idps"
      :cd-entity-id="hubId"
      :cd-entity-type="entityType"
      data-testid="confirmation-dialog-link" 
      @clickOutSide="dialogVisible=false"
      @close="dialogVisible=false"
      @proceedSubmit="login"
      @proceedLink="createNewAccount"
    />
    <ConfirmationDialogChangeSharingSettings
        v-if="dialogVisibleChangeSharingSettings"
        ref="confirmationDialogChangeSettings"
        :visible="dialogVisibleChangeSharingSettings"
        :cd-title="confirmationDialogTitle" 
        :cd-submit-btn="confirmationDialogSubmitBtn" 
        :cd-cancel-btn="confirmationDialogCancelBtn" 
        :loading="loadingUpdate"
        :activity-sharing-settings="sharingSetting"
        type="hub"
        :auto-share-with-activities="autoShareWithActivities"
        data-testid="confirmation-dialog-change-sharing-settings" 
        @close="dialogVisibleChangeSharingSettings= false"
        @proceedSubmit="changeSharingSettings"
      />
    <EditHub
      v-if="isAuth && role == 'booster' && visibleDialogHubSettingsDialog && !mobile()"
      :visible="visibleDialogHubSettingsDialog"
      :hub-id="hubId"
      :hub-title="hubTitle"
      :hub-description="hubDescription"
      :hub-image-u-r-l="coverImage"
      :hub-image-path="coverPath"
      :hub-sharing-settings="sharingSetting"
      :hub-auto-share="autoShare"
      :hub-tags="hubtags"
      :auto-share-with-activities="autoShareWithActivities"
      @close="visibleDialogHubSettingsDialog= false"
      @proceedSubmit="updateHub"
    />
  </div>
</template>

<script>
import {eventBus} from '../eventbus'
import VClamp from 'vue-clamp';
import { getHub, updateHub, createRequestToBecomeOwner } from '../api/hubApi'
import ConfirmationDialogWithLink from './ConfirmationDialogWithLink.vue'
import { repeatedMethodsMixin } from '../mixins/repeatedMethodsMixin'
import i18n from '../plugins/i18n'
import AlertMessages  from './AlertMessages'
import SystemBarTopTrial from '../components/SystemBarTopTrial';
import SystemBarTopCancelSubscription from '../components/SystemBarTopCancelSubscription'
import SystemBarTopPaymentFailed from '../components/SystemBarTopPaymentFailed'
import EditHub from '../views/hubs/EditHub'
import ConfirmationDialogChangeSharingSettings from './ConfirmationDialogChangeSharingSettings.vue'
import { ruleRequired, ruleValidMin2Max70Characters } from '../rules/formRules.js';
import focusOutside from 'vue-focus-outside'
import ContactUs from '../components/ContactUs';
import ConfirmationDialog from "../components/ConfirmationDialog.vue";

export default {
    components: {
        VClamp,
        AlertMessages,
        ConfirmationDialogWithLink,
        SystemBarTopTrial,
        SystemBarTopCancelSubscription,
        SystemBarTopPaymentFailed,
        EditHub,
        ConfirmationDialogChangeSharingSettings,
        ContactUs,
        ConfirmationDialog
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            valid: true,
            isAuth: window.$cookies.get("token")? true: false,
            drawer: null,
            pages: [],
            hubTitle: '',
            titleRules: ruleRequired('labelTitle').concat(ruleValidMin2Max70Characters('labelTitle')),
            spaceId: window.$cookies.get('space_id'),
            space: window.location.host.split('.')[0],
            subscriptionEnds: localStorage.space? JSON.parse(localStorage.space).subscription_ends_at: '',
            logo: localStorage.space ? JSON.parse(localStorage.space).logo : null,
            icon: localStorage.space ? JSON.parse(localStorage.space).icon : null,
            idps: localStorage.space ? JSON.parse(localStorage.space).idps : [],
            hubId: this.$route.params.id,
            entityType: "hub",
            hubType:'',
            hubTypeName: '',
            alertMsg: '',
            alertType: '',
            alertValue:false,
            role:'',
            confirmationDialogTitle: '',
            confirmationDialogText: '',
            confirmationDialogCancelBtn: '',
            confirmationDialogSubmitBtn: '',
            confirmationDialogLinkBtn:'',
            cdSubmitBtnColor:'',
            cdCancelBtnColor:'',
            dialogVisible: false,
            loadingData: false,
            sharingSetting:'',
            email: localStorage.user ? JSON.parse(localStorage.user).email : '',
            first_name: localStorage.user ? JSON.parse(localStorage.user).first_name : '',
            last_name: localStorage.user ? JSON.parse(localStorage.user).last_name : '',
            avatar: localStorage.user ? JSON.parse(localStorage.user).avatar_thumb : null,
            language: localStorage.user ? JSON.parse(localStorage.user).language : '',
            site_url: window.location.origin,
            costumer_name:localStorage.space ? JSON.parse(localStorage.space).subdomain : '',
            roleInSpace: localStorage.space ? JSON.parse(localStorage.space).role : null,
            exitPath: null,
            visibleDialogHubSettingsDialog: false,
            hubDescription:'',
            coverPath: null,
            coverImage: null,
            hubtags: [],
            dialogVisibleChangeSharingSettings: false,
            loadingUpdate: false,
            showHubTitle:false,
            counter: 0,
            autoShare: false,
            autoShareWithActivities: false,
            showCopiedLink:false,
            dialogRequestOwnerRights: false,
            userId: window.$cookies.get('id')
        }
    },
    computed:{
      productPlan() {
          return this.$store.state.productPlan
      }
    },
    directives: {
      focusOutside
    },
    async created(){
        eventBus.$on('setHubExitBtn',(data)=>{
            if(this.exitPath == null){
                this.exitPath = data.path
            }
        })
        eventBus.$on('setHubTitle',(data)=>{
            this.hubTitle = data
        })

        eventBus.$on('setHubAutoShareWithActivities',(data)=>{
            this.autoShareWithActivities = data
        })
        this.loadingData = true
        if(this.roleInSpace && this.roleInSpace != "NA" ){
        await this.getHub()
        }
        this.loadingData = false 
    },
    beforeDestroy() {
        eventBus.$off('setHubExitBtn')
        eventBus.$off('setHubTitle')
        eventBus.$off('setHubAutoShareWithActivities')
    },
    methods:{
        openHubSettingsDialog(){
            this.visibleDialogHubSettingsDialog = true
        },
        showEditTitleField(){
         this.showHubTitle = true
        },
        async onClickOutside () {
          await this.getHub()
          this.showHubTitle = false
        },
        async getHub(){
            try {
                const response = await getHub(this.hubId)
                if(response.status == 200) {
                    this.hubTitle = response.data.data.attributes.title
                    this.hubDescription = response.data.data.attributes.description
                    this.hubType = response.data.data.attributes.sharing_setting
                    this.role = response.data.data.attributes.role
                    this.sharingSetting = response.data.data.relationships['sharing-setting'].data.id
                    this.coverImage = response.data.data.attributes.image
                    this.autoShareWithActivities = response.data.data.attributes.auto_share_with_activities
                    this.hubtags = response.data.data.attributes.tags

                    if (this.hubType == 'Restricted') {
                      this.showCopiedLink = false
                        this.hubTypeName = i18n.t('sharingSettingRestricted')
                    } else {
                      this.showCopiedLink = true
                        this.hubTypeName = i18n.t('sharingSettingOpen')
                    }
                    this.autoShare = response.data.data.attributes.sync_with_space_members

                }  
            } catch (e) {
                if(e.response){
                  this.alertValue = true
                  this.alertType = 'error'
                  this.alertMsg =  i18n.t('serverError')
                } 
            }
        },
        copySharingLink(){
            const el = document.createElement('textarea');  
            el.value = window.location.origin +'/hub/'+this.hubId
            document.body.appendChild(el);                          
            el.select();                                    
            document.execCommand('copy');                   
            document.body.removeChild(el);                  
            this.alertMsg = i18n.t('copySharingLinkHubSuccessMsg');
            this.alertType = 'success' 
            this.alertValue = true  
        },
        createNewAccount(){
            window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/register?referer=" + this.space + '.' + process.env.VUE_APP_DOMAIN + "/hub/" + this.hubId 
        },
        login(){
            window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/login?referer=" + this.space + '.' + process.env.VUE_APP_DOMAIN + "/hub/" + this.hubId
        },
        openPeopleInHub(){
            this.$router.push({path: '/hub/' + this.hubId + '/overview'})
        },
        exitHub(){
            if (this.exitPath !== null) {
                this.$router.push({path: this.exitPath})
            } else {
                this.$router.push({path: '/'})  
            }
        },
        updateHub(msg, type, name, descriptionHub, cover, coverPath, sharingSettings, autoShare, tags){
            this.alertType= type
            this.alertMsg = msg
            this.alertValue = true
            this.hubTitle = name
            this.hubDescription = descriptionHub
            this.coverImage = cover
            this.coverPath = coverPath
            this.sharingSetting = sharingSettings
            this.autoShare = autoShare
            this.hubtags = tags
            eventBus.$emit('setHubDescription',this.hubDescription)
            eventBus.$emit('setHubImage',this.coverImage)
            if (this.sharingSetting == 1) {
                this.hubTypeName = i18n.t('sharingSettingRestricted')
            } else {
                this.hubTypeName = i18n.t('sharingSettingOpen')
            }
            eventBus.$emit('setSharingSettings', this.sharingSetting)
        },

        async changeSharingSettings(id){
          if(id == null){
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg =  i18n.t('serverError')
            this.dialogVisibleChangeSharingSettings = false
          } else{
            this.loadingUpdate = true
            try{
                  let data = {
                      data: {
                          type: "hubs",
                          id: this.hubId,
                          attributes: {
                              title: this.hubTitle
                          },
                            relationships: {
                                  space: {
                                      data: {
                                          type: "spaces",
                                          id: this.spaceId
                                      }
                                  },
                                  "sharing-setting": {
                                      data: {
                                          type: "sharing-settings",
                                          id: id
                                      }
                                  }
                              }
                      }
                  }
                  const response = await updateHub(this.hubId, data)
                  if(response.status == 200) {
                      this.hubType = response.data.data.attributes.sharing_setting
                      this.sharingSetting = response.data.data.relationships['sharing-setting'].data.id
                      if (this.hubType == 'Restricted') {
                          this.hubTypeName = i18n.t('sharingSettingRestricted')
                      } else  {
                          this.hubTypeName = i18n.t('sharingSettingOpen')
                      }
                      eventBus.$emit('setSharingSettings', this.sharingSetting)
                  }
              } catch (e) {
                  if(e.response){
                      this.alertValue = true
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError')
                  }
              }
            this.dialogVisibleChangeSharingSettings = false
            this.loadingUpdate = false
          }
        },
        async editTitle(){
            if(this.valid){
                    let data = {
                        data: {
                            type: "hubs",
                            id: this.$route.params.id,
                            attributes: {
                                title: this.hubTitle.trim()
                            },
                            relationships: {
                                space: {
                                    data: {
                                        type: "spaces",
                                        id: this.spaceId
                                    }
                                }
                            }
                        }
                    };
                    try {
                        const response = await updateHub(data.data.id, data)
                        if(response.status == 200) {
                          await this.getHub()
                            //updated - do not show anything
                        }
                    } catch (e) {
                        if(e.response){
                            if (e.response.status == 403){
                                for(let i = 0; i < e.response.data.errors.length; i++){
                                    if(e.response.data.errors[i].detail == 'This action is unauthorized.'){
                                        this.$router.push({name: 'PageAccessDenied'})
                                    }
                                    else {
                                        this.alertValue = true
                                        this.alertType = 'error'
                                        this.alertMsg =  i18n.t('serverError')
                                    }
                                }
                            } else{
                                this.alertType = 'error'
                                this.alertMsg =  i18n.t('serverError') 
                                this.alertValue = true
                            }           
                        }
                    }
                     this.showHubTitle = false
            }
        },

        async sendRequestOwnerRights(){
          try {
            let data = {
              data: {
                type: "requests-owner-rights",
                  relationships: {
                    user: {
                      data: {
                        type: "users",
                        id: this.userId
                      }
                    },
                    requestable: {
                      data: {
                        type: "hubs",
                        id: this.$route.params.id
                      }
                    }
                  }
              }
            };
            const response = await createRequestToBecomeOwner(data)
            if(response.status == 200) {
              this.alertValue = true
              this.alertType = 'success'
              this.alertMsg =  i18n.t('requestOwnerRightsSuccess')
              this.dialogRequestOwnerRights = false            
            }            
          } catch (e) {
              if(e.response){
                  if (e.response.status == 403){
                    this.$router.push({name: 'PageAccessDenied'})
                  } else if(e.response.status == 404) {
                    this.$router.push({name: 'PageNotFound'})
                  } else {
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                    this.dialogRequestOwnerRights = false 
                  }
              }            
          }
        }
    }
}
</script>

